import { z } from 'zod'
import { TemplateId } from './id.js'

/**
 * Uit welk sjabloon en welke versie een formulier is gemaakt (D-34, besluit van 1 november 2026).
 *
 * **Herkomst en nooit een tweede waarheid**, net als het merk van een standaardveld (`FieldOrigin`).
 * Niets leidt de vorm van een formulier eruit af, en niets werkt een formulier bij als het sjabloon een
 * nieuwe versie krijgt (D-36). Het gaat mee in de publicatie, zodat per dossier aanwijsbaar is uit welk
 * sjabloon en welke versie het formulier kwam; dat versterkt R-101 en past bij het "Call
 * sjabloon-versie nr" uit het aanbestedingsdossier.
 *
 * Een eigen bestand, omdat zowel de conceptvorm als de strikte definitie hem draagt en die twee elkaar
 * importeren in één richting.
 */
export const TemplateOrigin = z.strictObject({
  sjabloon: TemplateId,
  versie: z.number().int().min(1),
})
export type TemplateOrigin = z.infer<typeof TemplateOrigin>
